export default "__VITE_ASSET__WCFrYSXF__"